import { NoteCardView } from '../view/NoteCardView';
import { templateNoteCard } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { NoteCardWebComponent } from '../index';
import { NoteMenuActions } from '../types';
import { SelectEvents } from '../../../ui/gzSelect/types';
import { Note } from '../../types';

export class NoteCardController extends BaseWebComponentController {
  public component: NoteCardWebComponent;
  public view: NoteCardView;
  public viewConstructor: typeof NoteCardView;

  constructor(component: NoteCardWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: NoteCardView,
      viewTemplate: templateNoteCard,
    });
  }

  async getDataForView(): Promise<Note> {
    return this.component.note;
  }

  public computeEventListeners() {
    return [
      {
        element: this.view.dom.$sectionContainer,
        event: SelectEvents.SELECTION_CHANGED,
        callback: this.changedHandler,
      },
    ];
  }

  async changedHandler(ev: WebComponentEvent): Promise<any> {
    switch (ev.detail.selected) {
      case NoteMenuActions.EDIT:
        await this.openUpdateNoteComponent(ev);
        return;
      case NoteMenuActions.DELETE:
        await this.openDeleteNoteComponent(ev);
        return;
    }
  }

  private async openUpdateNoteComponent(event: WebComponentEvent) {
    this.component.dispatchEvent(
      new CustomEvent('editNoteCard', {
        detail: {
          noteRequest: {
            text: this.component.note.text,
            _id: this.component.note._id,
          },
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  private async openDeleteNoteComponent(event: WebComponentEvent) {
    this.component.dispatchEvent(
      new CustomEvent('deleteNoteCard', {
        detail: {
          noteRequest: {
            _id: this.component.note._id,
          },
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }
}
